/**
 * Подпись суммы над столбцом графика: цифры («12,4») — салатовым и жирно, единица («тыс. ₽») — обычным мелким цветом. Цвет
 * не единственный носитель смысла: единица написана словами, а подпись продублирована в `aria-label` кнопки столбца.
 */
export function TrendSum({ text }: { text: string }) {
  const cut = text.lastIndexOf(' тыс.')
  if (text === '' || cut < 0) return <span>{text}</span>
  return (
    <span>
      <b className="krp-trend__sum">{text.slice(0, cut)}</b>
      {text.slice(cut)}
    </span>
  )
}
